import RecruitingContext from '@contexts/RecruitingContext';
import React, { useContext } from 'react';

function useRecruiting() {
    return useContext(RecruitingContext);
}

export default useRecruiting;